import { openBlock as l, createElementBlock as t, createElementVNode as e } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, c = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M5.583 7.113a11.284 11.284 0 0 1 12.834 0 .77.77 0 0 1 .186 1.086l-2.977 4.092a.776.776 0 0 1-1.068.184 4.494 4.494 0 0 0-5.116 0 .776.776 0 0 1-1.068-.184L5.397 8.2a.77.77 0 0 1 .186-1.086Zm1.485.834 2.129 2.925a6.002 6.002 0 0 1 1.957-.636l.572-1.57a.75.75 0 1 1 1.41.512l-.381 1.045c.706.09 1.4.306 2.048.65l2.129-2.926a9.772 9.772 0 0 0-9.864 0Z",
  "clip-rule": "evenodd"
}, null, -1), n = /* @__PURE__ */ e("path", {
  "fill-rule": "evenodd",
  d: "M1.25 5A2.75 2.75 0 0 1 4 2.25h16A2.75 2.75 0 0 1 22.75 5l.003 14a2.75 2.75 0 0 1-2.75 2.75l-16.007-.002a2.75 2.75 0 0 1-2.75-2.75L1.25 4.999ZM4 3.75c-.69 0-1.25.56-1.25 1.25l-.004 13.998c0 .69.56 1.25 1.25 1.25l16.007.002c.69 0 1.25-.56 1.25-1.25L21.25 5c0-.69-.56-1.25-1.25-1.25H4Z",
  "clip-rule": "evenodd"
}, null, -1), d = [
  c,
  n
];
function r(a, s) {
  return l(), t("svg", o, [...d]);
}
const h = { render: r };
export {
  h as default,
  r as render
};
